<template>
  <el-dialog :visible="visible" :title="adding ? '添加银行卡' : '银行卡管理'"
    width="480px" top="10vh" custom-class="bank-cards-dialog" append-to-body
    :close-on-click-modal="false" :before-close="close" @open="open">
    <div v-if="!adding" class="bank-list" v-loading="loading">
      <p v-if="loadFailed" class="bank-empty">银行卡加载失败 <el-button type="text" @click="loadCards">重试</el-button></p>
      <p v-else-if="!loading && !cards.length" class="bank-empty">暂无银行卡</p>
      <button v-for="card in cards" :key="card.id" class="bank-card" :disabled="busy || loading"
        :aria-label="'解绑' + card.bank_name + '银行卡，尾号' + String(card.bank_card).slice(-4)" @click="removeCard(card)">
        <span class="bank-name"><i class="el-icon-bank-card" aria-hidden="true"></i>{{ card.bank_name }}<small>解绑</small></span><span>{{ card.bank_card }}</span>
      </button>
      <p v-if="cards.length" class="bank-hint">点击银行卡可解绑</p>
      <button class="bank-submit" :disabled="busy || loading" @click="startAdding">添加银行卡</button>
    </div>
    <div v-else class="bank-add" v-loading="loading">
      <button class="bank-back" :disabled="busy || loading" @click="adding = false"><i class="el-icon-arrow-left" aria-hidden="true"></i> 返回银行卡列表</button>
      <el-form ref="form" :model="form" :rules="rules" label-width="110px" class="bank-form" @submit.native.prevent="addCard">
        <el-form-item label="姓名" prop="bank_user">
          <el-input v-model="form.bank_user" :disabled="authenticated || busy || loading || userFailed" placeholder="请输入认证人本人姓名" />
        </el-form-item>
        <el-form-item label="银行卡" prop="bank_card">
          <el-input v-model="form.bank_card" :disabled="busy || loading" inputmode="numeric" maxlength="19" placeholder="请输入认证人本人银行卡号" />
        </el-form-item>
        <el-form-item label="银行名称" prop="bank_name">
          <el-input v-model="form.bank_name" :disabled="busy || loading" placeholder="请输入认证人本人银行名称" />
        </el-form-item>
        <p v-if="userFailed" class="bank-empty">姓名信息加载失败 <el-button type="text" @click="loadUser">重试</el-button></p>
        <button class="bank-submit" type="submit" :disabled="busy || loading || userFailed">{{ busy ? '正在提交…' : '确认添加' }}</button>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
import { apiCards, apiAddCard, apiDealCard, apiUserInfo } from '@/utils/requestapis'

export default {
  name: 'BankCardsDialog',
  props: { visible: Boolean },
  data() {
    return {
      cards: [], adding: false, loading: false, busy: false,
      loadFailed: false, userFailed: false, authenticated: false,
      form: { bank_user: '', bank_card: '', bank_name: '' },
      rules: {
        bank_user: [{ required: true, whitespace: true, message: '请输入认证人本人姓名', trigger: 'blur' }],
        bank_card: [{ required: true, message: '请输入认证人本人银行卡号', trigger: 'blur' },
          { pattern: /^\d{16,19}$/, message: '请输入16至19位数字银行卡号', trigger: 'blur' }],
        bank_name: [{ required: true, whitespace: true, message: '请输入认证人本人银行名称', trigger: 'blur' }]
      }
    }
  },
  methods: {
    close(done) {
      if (this.busy || this.loading) return
      this.$emit('update:visible', false)
      done()
    },
    open() {
      this.adding = false
      this.loadCards()
    },
    async loadCards() {
      this.loading = true
      this.loadFailed = false
      this.cards = []
      try {
        const cards = await apiCards({})
        if (!Array.isArray(cards)) { this.loadFailed = true; return }
        this.cards = cards
      } catch (_) {
        this.loadFailed = true
      } finally { this.loading = false }
    },
    async startAdding() {
      this.form = { bank_user: '', bank_card: '', bank_name: '' }
      this.authenticated = false
      this.adding = true
      await this.loadUser()
    },
    async loadUser() {
      this.loading = true
      this.userFailed = false
      try {
        const user = await apiUserInfo({})
        if (!user || typeof user !== 'object') { this.userFailed = true; return }
        this.authenticated = Number(user.authentication) === 1
        if (this.authenticated) this.form.bank_user = user.real_name || ''
      } catch (_) {
        this.userFailed = true
      } finally { this.loading = false }
    },
    async addCard() {
      if (this.busy || this.loading || this.userFailed) return
      this.form.bank_user = this.form.bank_user.trim()
      this.form.bank_name = this.form.bank_name.trim()
      this.form.bank_card = this.form.bank_card.trim()
      this.busy = true
      try {
        const valid = await new Promise(resolve => this.$refs.form.validate(resolve))
        if (!valid) return
        const result = await apiAddCard({ ...this.form })
        if (result === 0 || result === undefined) return
        this.$message.success('银行卡添加成功')
        this.adding = false
        await this.loadCards()
      } catch (_) {
        // The shared request interceptor displays request failures.
      } finally { this.busy = false }
    },
    async removeCard(card) {
      if (this.busy || this.loading) return
      this.busy = true
      try {
        await this.$confirm('是否解绑此银行卡？（尾号' + String(card.bank_card).slice(-4) + '）', '解绑银行卡',
          { confirmButtonText: '确认解绑', cancelButtonText: '取消', type: 'warning', customClass: 'settings-confirm' })
        const result = await apiDealCard({ id: card.id })
        if (result === 0 || result === undefined) return
        this.$message.success('银行卡解绑成功')
        await this.loadCards()
      } catch (_) {
        // Cancellation makes no changes; request failures are displayed by the interceptor.
      } finally { this.busy = false }
    }
  }
}
</script>

<style>
.bank-cards-dialog { max-width:calc(100vw - 32px); background:var(--theme-panel); border-radius:6px; overflow:hidden; }
.bank-cards-dialog .el-dialog__header { text-align:left; padding:14px 18px; background:var(--theme-header); border-bottom:1px solid var(--theme-border); }
html[data-theme] .bank-cards-dialog .el-dialog__title { color:var(--theme-label); font-size:15px; font-weight:500; }
.bank-cards-dialog .el-dialog__headerbtn { top:16px; right:18px; }.bank-cards-dialog .el-dialog__close { color:var(--theme-muted); }
.bank-cards-dialog .el-dialog__body { height:auto; max-height:65vh; overflow-y:auto; padding:18px; font-size:13px; line-height:1.6; word-break:normal; }
.bank-cards-dialog button { font:inherit; cursor:pointer; }.bank-cards-dialog button:disabled { opacity:.6; cursor:not-allowed; }.bank-cards-dialog button:focus-visible { outline:2px solid var(--theme-accent); outline-offset:2px; }
.bank-cards-dialog .bank-card { display:block; width:100%; padding:14px 16px; margin-bottom:10px; text-align:left; border:1px solid var(--theme-border); border-radius:6px; background:var(--theme-header); color:var(--theme-label); }.bank-cards-dialog .bank-card:hover { border-color:var(--theme-accent); }
.bank-cards-dialog .bank-card > span { display:block; overflow-wrap:anywhere; }.bank-cards-dialog .bank-card .bank-name { display:flex; align-items:center; gap:8px; font-size:14px; }.bank-cards-dialog .bank-name small { margin-left:auto; color:var(--theme-accent); font-size:12px; }.bank-cards-dialog .bank-card > span + span { margin-top:12px; color:var(--theme-text); font-size:16px; letter-spacing:1px; }
.bank-cards-dialog .bank-submit { display:block; width:100%; min-height:36px; margin:16px auto 0; border:1px solid var(--theme-accent); border-radius:4px; background:var(--theme-accent); color:var(--theme-on-accent); font-size:13px; }
.bank-cards-dialog .bank-empty,.bank-cards-dialog .bank-hint { text-align:center; color:var(--theme-muted); font-size:12px; }.bank-cards-dialog .bank-empty { padding:18px 0; }
.bank-cards-dialog .bank-back { padding:0 0 16px; background:none; border:0; color:var(--theme-accent); }.bank-cards-dialog .bank-form { padding:0; }
.bank-cards-dialog .el-form-item { margin-bottom:18px; }.bank-cards-dialog .el-form-item__label { color:var(--theme-label); font-size:13px; line-height:36px; text-align:left; }.bank-cards-dialog .el-form-item__content { line-height:36px; }
html[data-theme] .bank-cards-dialog .el-input__inner { height:36px; line-height:36px; border:1px solid var(--theme-border); border-radius:4px; background:var(--theme-input); color:var(--theme-text); font-size:13px; padding:0 10px; }
.bank-cards-dialog .el-input__inner::placeholder { color:var(--theme-muted); }html[data-theme] .bank-cards-dialog .el-input.is-disabled .el-input__inner { color:var(--theme-muted); background:var(--theme-header); }
.bank-cards-dialog .el-input__inner:focus { border-color:var(--theme-accent); }.bank-cards-dialog .el-form-item__error { color:var(--theme-danger); }.bank-cards-dialog .el-button--text { color:var(--theme-accent); }
</style>
